export default {
  title: {
    register: 'First-Time Login Registration',
    login: 'Login',
    logout: 'Logout'
  },
  label: {
    plzSetting: 'Please set your email and password for your account',
    setNewPassword: 'Please set a new password for your account',
    editPassword: 'Change Password',
    newPassword: 'Set New Password',
    passwordNew: 'New Password',
    oldPassword: 'Current Password',
    inputOldPassword: 'Enter current password',
    inputNewPassword: 'Enter new password',
    newPasswordConfirmation: 'Confirm new password',
    myAccount: 'My Account',
    password: 'Password',
    confirmPass: 'Confirm Password',
    confirmNewPassword: 'Confirm New Password',
    passwordChangeSuccess: 'Password changed successfully',
    confirm: 'Confirm',
    welcome: 'Welcome!',
    forgetPass: 'Forgot Password?',
    passwordResetEmailMessage: 'You will receive an email with instructions on how to reset your password',
    sendEmail: 'Send Email',
    signName: 'Sign Name',
    emailSuccessMessage: 'Email sent successfully',
    checkEmailNotice: 'We have sent information to your email. Please check your inbox.',
    emailRetryNotice: 'It may take 2–3 minutes. If you don’t receive the email, please try again.'
  },
  placeholder: {
    confirmPass: 'Enter password confirmation',
    password: 'Enter password',
    keepPassword: 'Remember your password',
    plzEnterEmail: 'Please enter your email',
    plzEnterClinicDetail: 'Please enter the details to create a new clinic'
  },
  toolTip: {
    ok: 'Okay, I understand'
  },
  modal: {
    create: {
      user: {
        success: 'User created successfully !'
      },
      clinic: {
        title: 'Create Clinic',
        newClinic: 'New Clinic Registration',
        success: 'New clinic created successfully',
        success2: 'Clinic creation completed'
      }
    }
  }
}
